import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { Gift, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Richiamo natalizio in homepage.
 * Nascosto finché il flag "Pagina ATTIVA" del Calendario dell'Avvento è spento:
 * si accende automaticamente quando Teresa attiva il calendario dall'admin.
 */
export default function AdventHomeBanner() {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    axios.get(`${API}/advent/banner`)
      .then((r) => { if (r.data?.show) setBanner(r.data); })
      .catch(() => {});
  }, []);

  if (!banner) return null;

  const cover = banner.cover_image_url
    ? (banner.cover_image_url.startsWith("http") ? banner.cover_image_url : `${process.env.REACT_APP_BACKEND_URL}${banner.cover_image_url}`)
    : "";

  return (
    <section className="px-6 md:px-10 py-16 md:py-24 bg-gradient-to-b from-[#FFE4E8]/60 to-[#FAF8F5]" data-testid="advent-home-banner">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center gap-10">
        {cover && (
          <motion.img
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            src={cover}
            alt="24 giorni per crescere con cura — Il nostro Calendario dell'Avvento 2026"
            className="w-full max-w-[280px] md:max-w-xs h-auto rounded-3xl shadow-xl"
          />
        )}
        <div className="text-center md:text-left">
          <p className="text-[10px] uppercase tracking-[0.4em] text-[#FF2768] font-semibold mb-3 flex items-center justify-center md:justify-start gap-2">
            <Gift size={14} /> Natale 2026
          </p>
          <h2 className="font-display text-3xl md:text-5xl text-[#3D2140] leading-[1.05] mb-4">
            Il nostro Calendario dell'Avvento è arrivato
          </h2>
          <p className="text-[#3D2140]/75 leading-relaxed mb-6 max-w-md">
            {banner.hero_subtitle} Dal 1° al 24 dicembre, una casella si apre ogni giorno.
          </p>
          <Link
            to="/calendario-avvento-2026"
            data-testid="advent-home-cta"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#FF2768] text-white font-semibold text-sm hover:bg-[#c81e52] transition-colors shadow-lg"
          >
            Apri il calendario <ArrowRight size={15} />
          </Link>
        </div>
      </div>
    </section>
  );
}
